import { Config } from 'modules/config/state/config-types'
import { useEffect } from 'react'

declare global {
  interface Window {
    SC: {
      ab_testing: {
        cid?: string
        oid?: string
        donation_type: string
        campaign_type: string
      }
    }
  }
}

const useSC = (config: Config) => {
  useEffect(() => {
    window.SC = {
      ab_testing: {
        cid: config.campaignId,
        oid: config.organizationId,
        donation_type: 'studio_embedded',
        campaign_type: config.campaignType,
      },
    }
  }, [config])
}

export default useSC
